import AspectRatio from '@blocks/AspectRatio'
import Input from '@blocks/Input'
import Image from '@blocks/Input/Image'
import TextArea from '@blocks/Input/TextArea'
import React from 'react'

export default function SectionForm({ model: section }: Modules.Resource.Form<Interfaces.Section>) {
    return (
        <>
            <Input id="name" name="name" label="Name" placeholder="Open Monochrome" defaultValue={section?.name} required />
            <TextArea id="description" name="description" label="Description" placeholder="Description" defaultValue={section?.description} required />
            <AspectRatio width={16} height={9}>
                <Image id="avatar" name="illustration" src={section?.illustration_url} />
            </AspectRatio>
            <Input id="author" name="author" label="Author" placeholder="John Blake" defaultValue={section?.author} required />
        </>
    )
}